// extracted by css-extract-rspack-plugin
export default {"Flash":"OverridingGlobalFundingFileWarning-module__Flash__M27zG"};